/* File generated by vital-package-manager. DO NOT EDIT! */

import './nav-controller';



// WEBPACK FOOTER //
// ./wp-content/themes/synergy/assets/scripts/source/vpm/index.js